<template>  
    <section>
		<common-modal :showClose="true" v-if="isShowModal" @close-modal="onCloseModalClick">
		    <div class="modal">
		        <div class="title">选择权限类型</div>
		        <ul class="list-wrap">
		            <li v-for="(item,index) in shouHouList" :key="index">
		                <span class="select-mark" @click="selectAfter(item,index)" :class='shouHouFlag==index?"done":"undone"'></span>
		                <span class="modal-text">{{item}}</span>
		            </li>
		        </ul>
		        <div class="modal-submit" @click="submitAfter">确定</div>
		    </div>
		</common-modal>
		
		<common-modal :showClose="true" v-if="isShowTips" @close-modal="onCloseModalClick">
		    <div class="tips-all">增加此权限给于处理人员更多的权限，可提高处理效率及成功率</div>
		</common-modal>	
		
        <ul class="service-all">
            <li>
                <h1 class="service-title">*服务项目</h1>
                <div class="service-pro" @click="showPicker(1)">
                    <span class="service-l">项目类型</span>
                    <div class="right-arrow-wrap">
						<span class="service-case"></span>
                    </div>
                </div>

                <div class="service-pro m-d">
					<img :src="imgUrl+serverIcon" alt="" class="server-icon">
                    <span class="service-left service-type">{{serverName}}</span>
                    <span class="service-price">¥{{serverPrice}}</span>
                </div>
                
                <div class="goods-link">
                    <div class="service-left goods-left" v-text='serverType==1?"商品链接":"店铺链接"'></div>
					<textarea rows="3" cols="20" class="link-detail" v-model="info.linkUrl"></textarea>
                </div>
                
            </li>
            
            <li>
                <h1 class="service-title">*消费者信息</h1>
                <div class="service-content">
                    <span class="service-left">消费者姓名</span>
                    <input class="service-right" placeholder="请输入名字" type="text" v-model="info.consumerName">
                </div>
             
                <div class="service-content" v-if="serverType==1">
                    <span class="service-left">消费者旺旺</span>
                    <input class="service-right" placeholder="请输入旺旺号" type="text" v-model="info.consumerWang">
                </div>
                <div class="service-content no-border">
                    <span class="service-left">手机号码</span>
                    <input class="service-right" placeholder="请输入手机号" type="tel" maxlength="11" v-model="info.consumerMobile">
                </div>
            </li>
            
            <li>
                <h1 class="service-title">*商家信息</h1>
                <div class="service-content" v-if="serverType==1">
                    <span class="service-left">商家旺旺</span>
                    <input class="service-right" placeholder="请输入旺旺号" type="text" v-model="info.merchantWang">
                </div>
                <div class="service-content no-border">
                    <span class="service-left">手机号码</span>
                    <input class="service-right" placeholder="请输入手机号" type="tel" maxlength="11" v-model="info.merchantMobile">
                </div>
            </li>
			
			<li>
			    <h1 class="service-title">
					售后特权
					<img src="../../assets/images/order-manage/ic_question.png" class="tips" @click="isShowTips = true">
				</h1>
			    <div class="service-pro" @click="selectService">
			        <span class="service-l">权限类型</span>
			        <div class="right-arrow-wrap">
			            <i class="service-case"></i>
			        </div>
			    </div>

			    <div class="service-pro m-d">
			        <span class="service-left">{{afterSale}}</span>
			    </div>
				
				<div class="goods-link area-pt" v-if='shouHouFlag==3'>
					<textarea rows="3" cols="20" class="link-detail" placeholder="请简述权限类型"  v-model="info.otherMassage"></textarea>
				</div>
				
				<div class="service-content no-border" v-if='shouHouFlag==1'>
				    <span class="service-left">最大允许补偿金额</span>
				    <input class="service-right" placeholder="请输入金额" type="tel" v-model="info.compensationPrice">
				</div>
			</li>
			
			<li>
			    <h1 class="service-title">情况概括</h1>
			    <div class="service-content" @click="showPicker(2)">
			        <span class="service-left">大致情况</span>
			        <div class="right-arrow-wrap">
			            <span class="service-case">{{situlation}}</span>
			        </div>
			    </div>

			    <div class="goods-link have-border">
			        <div class="service-left goods-left">实际情况</div>
					<textarea rows="3" cols="20" class="link-detail" placeholder="麻烦亲简述处理进展及答应消费者的条件，以便尽快帮您解决哈，谢谢亲！" v-model="info.caseDetails"></textarea>
			    </div>
			</li>
			
			<li>
				<div class="service-content no-border">
					<span class="img-upload">*图片上传({{ addBody.feedback_images.length }}/9）</span>
					<span class="img-expmle" @click="lookExample">
						查看示例
						<img :src="item" ref="example" v-for="(item, ins) in imgList " :key="ins" @click="handleImgsClick(imgList,ins)"  alt="" class="upload_img">
					</span>
				</div>
				<p class="img-text">{{message}}</p>
				
                <div class="img-list">
					<imageUpload  v-model="addBody.feedback_images" :limit="9"/>
                </div>
			</li>
        </ul>
        <submit-pay @submitClick="submitClick" :money="serverPrice" :step="step"></submit-pay>
    </section>
</template>

<script>
	import CommonModal from '@/components/CommonModal';
	import imageUpload from '@/components/ImageUpload';
    import CommonHeader from '@/components/CommonHeader'
    import submitPay from '@/components/submitPay'
	import {getServer} from '@/api/home'
	import {placeOrder,getOrderHistory,getOrderDetail} from '@/api/order'
	import {getCommunal} from '@/api/common'
    import utils from '@/assets/jslibs/utils'
    // import { mapState } from 'vuex'
    export default {
        name: 'service-order',
		data(){
			return{
                imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				step:"下一步",
				limit:9,      //限制图片数量
				serverList:[],
				selectShow:false,
				isAdmin:this.$route.query.isAdmin,
				serverPrice:sessionStorage.getItem("value")?JSON.parse(sessionStorage.getItem("value")).server_price:"",
				serverName:sessionStorage.getItem("value")?JSON.parse(sessionStorage.getItem("value")).server_name: "",
				serverIcon:sessionStorage.getItem("value")?JSON.parse(sessionStorage.getItem("value")).server_icon:"",
				serverType:sessionStorage.getItem("value")?JSON.parse(sessionStorage.getItem("value")).type : "",
				serverUuid:sessionStorage.getItem("value")?JSON.parse(sessionStorage.getItem("value")).uuid:"",
				caseImg:sessionStorage.getItem("value")?JSON.parse(sessionStorage.getItem("value")).case_img:"", //该服务项目的案例图片
				message:sessionStorage.getItem("value")?JSON.parse(sessionStorage.getItem("value")).message:"",   //案例描述
				situlation:"",
				// 大致情况选项
				column2 : [
					{ text: '电话联系不上',            value: '电话联系不上'},
					{ text: '旺旺没搭理',              value: '旺旺没搭理' },
					{ text: '答应消费者赔偿',          value: '答应消费者赔偿'},
					{ text: '答应消费者退货',          value: '答应消费者退货'},
					{ text: '消费者不同意删除',        value: '消费者不同意删除'},
					{ text: '有沟通不愉快(争吵或辱骂)', value: '有沟通不愉快(争吵或辱骂)'},
					{ text: '收货人不是本人',          value: '收货人不是本人'}
				],
				
				// 售后服务类型
				shouHouList:[
					'除处理费用外，商家还同意消费者申请退货退款',
					'除处理费用外，商家还愿意额外支付消费者补偿款',
					'除处理费用外，商家还同意消费者不退货仅退款',
					'其他'
				],
				
				// 售后服务类型选择标识
				shouHouFlag:-1,
				afterSale:"",
				info:{
					linkUrl:"",
					consumerName:"",  
					consumerWang:"",
					consumerMobile:"",
					
					// 商家
					merchantWang:"",
					merchantMobile:"",
					compensationPrice:"",  //补偿金额
					otherMassage:"", 	 //其它情况
					caseDetails:""      //实际情况
				},
				addBody: {
				  feedback: '',
				  feedback_images: [],
				},
				isShowModal:false,
				isShowTips:false
			}
			
		},
		
		beforeCreate(){
			if(this.$route.query.isAdmin && this.$route.query.isAdmin=="admin"){
				sessionStorage.removeItem("roleType");
			}else{
				sessionStorage.setItem("roleType","customer")
			}
		},
		
		created(){
			this.imgList = this.caseImg;
			if(this.imgList && this.imgList.length){
				this.imgList.forEach((idx,key)=>{
					if(idx.indexOf("https" || "http") == -1){
						this.imgList[key] = this.imgUrl + this.imgList[key]
					}
				})
			}
            
			if(!this.$route.query.isAdmin || this.$route.query.isAdmin!="admin"){//非管理员新建订单才获取用户上次填写商家信息
				this.getOrderHistory();
			}
			this.getServer();
            if(sessionStorage.getItem("placeOrderId") && !this.isAdmin){//从订单确认页返回
                var orderId = sessionStorage.getItem("placeOrderId");
                this.getOrderDetail(orderId);
            }
		},
        
        mounted(){
			document.title = "用心淘下单平台";
			let self = this;
			window.addEventListener('touchmove', (event)=>{ 
		       if(this.isShowModal || this.isShowTips){
		           event.preventDefault(); 
		       }
			}) 
        },
		
        methods: {
			//获取服务项目
			async getServer(){
				const { data, status } = await getServer();
				if (status !== 200) return 
				this.serverList = data.char;
				this.serverList.forEach((item,i)=>{
					item.text = item.server_name;
				})
				
				if(this.isAdmin && this.isAdmin=="admin"){//从订单确认页返回
                    if(sessionStorage.getItem("newOrder") && sessionStorage.getItem("newOrder")=="newOrder"){
                        var obj = JSON.parse(sessionStorage.getItem("params"))
                        this.serverIcon = obj.server_info.server_icon;
                        this.serverName = obj.server_info.server_name;
                        this.serverPrice = obj.server_info.server_price;
                        this.serverType = obj.server_info.type;                 //服务类型(1,2)
                        this.serverUuid = obj.server_info.uuid;                 //服务id
                        this.caseImg = obj.server_info.case_img;
                        this.message = obj.server_info.message;
                        
                        this.imgList = this.caseImg;
                        if(this.imgList && this.imgList.length){
                        	this.imgList.forEach((idx,key)=>{
                        		if(idx.indexOf("https" || "http") == -1){
                        			this.imgList[key] = this.imgUrl + this.imgList[key]
                        		}
                        	})
                        }
                        
                        this.info.linkUrl = obj.question_url;
                        this.info.consumerName = obj.consumer_name;
                        this.info.consumerWang = obj.consumer_wangwang;
                        this.info.consumerMobile = obj.consumer_mobile;
                        
                        this.info.merchantWang = obj.merchant_wangwang;
                        this.info.merchantMobile = obj.merchant_mobile;
                        
                        this.shouHouFlag = obj.after_sale_type - 1;             //售后类型 (1.2,3,4)
                        this.afterSale = obj.after_sale_name;                   //售后特权
                        
                        this.info.compensationPrice = obj.compensation_price;  //补偿金额
                        this.info.otherMassage = obj.other_sale_massage;        //其他情况
                        this.info.caseDetails = obj.order_details;              //订单实际情况
                        this.situlation = obj.order_details_tag;  
                        this.addBody.feedback_images =  obj.order_images;	 

                    }else{//管理员新建订单,默认选中第一条服务
                        this.serverPrice = this.serverList[0].server_price;
                        this.serverName = this.serverList[0].server_name;
                        this.serverIcon = this.serverList[0].server_icon;
                        this.serverType = this.serverList[0].type;
                        this.serverUuid = this.serverList[0].uuid;
                        this.caseImg = this.serverList[0].case_img;
                        this.message = this.serverList[0].message;
                        this.imgList = this.caseImg;					
                        if(this.imgList && this.imgList.length){//用于点击放大，直接拼上域名
                        	this.imgList.forEach((idx,key)=>{
                        		if(idx.indexOf("https") == -1){
                        			this.imgList[key] = this.imgUrl + this.imgList[key]
                        		}
                        	})
                        }
                    }
				}
			},
            
            //获取上次填写的下单信息，用于信息回填
            async getOrderDetail(order_uuid){
            	const { data, status } = await getOrderDetail(order_uuid);
            	if (status == 200){ 
                    this.serverIcon = data.server_info.server_icon;
                    this.serverName = data.server_info.server_name;
                    this.serverPrice = data.server_info.server_price;
                    this.serverType = data.server_info.type;
                    this.serverUuid = data.server_info.uuid;
                    this.caseImg = data.server_info.case_img;
                    this.message = data.server_message;
                    
                    this.imgList = JSON.parse(this.caseImg);
                    if(this.imgList && this.imgList.length){
                    	this.imgList.forEach((idx,key)=>{
                    		if(idx.indexOf("https" || "http") == -1){
                    			this.imgList[key] = this.imgUrl + this.imgList[key]
                    		}
                    	})
                    }

                    this.info.linkUrl = data.question_url;
                    this.info.consumerName = data.consumer_name;
                    this.info.consumerWang = data.consumer_wangwang;
                    this.info.consumerMobile = data.consumer_mobile;
                    
                    this.info.merchantWang = data.merchant_wangwang;
                    this.info.merchantMobile = data.merchant_mobile;
                    
                    this.afterSale = utils.typeToName(data.after_sale_type);     //售后特权
                    this.shouHouFlag = (data.after_sale_type) - 1;

                    this.info.compensationPrice = data.compensation_price;
                    this.info.otherMassage = data.other_sale_massage;
                    this.info.caseDetails = data.order_details;
                    this.situlation	 = data.order_details_tag;
                    this.addBody.feedback_images = data.order_images;
                }
            },
            
			//获取用户上次填写的商家信息
			async getOrderHistory(){
				const { data, status } = await getOrderHistory();
				if (status !== 200) return
				if(data.data){
					this.info.merchantWang = data.data.merchant_wangwang
					this.info.merchantMobile = data.data.merchant_mobile
				}
			},

			// 点击下一步
            submitClick(){
				if(!this.serverName){
					window.toast("请选择服务项目","txt");
					return
				};
				
				if(!this.info.linkUrl){
					if(this.serverType=="1"){
						window.toast("请输入商品链接","txt");
						return
					}else{
						window.toast("请输入店铺链接","txt");
						return
					}
					
				}
				
				if(!this.info.consumerName){
					window.toast("请输入消费者姓名","txt");
					return
				}
				
				if(this.serverType=="1"){
					if(!this.info.consumerWang){
						window.toast("请输入消费者旺旺号","txt");
						return
					}
				}
				
				if(!(/^1[0123456789]\d{9}$/.test(this.info.consumerMobile))){
					window.toast("消费者手机号有误","txt");
					return
				}
				
				if(this.serverType=="1"){
					if(!this.info.merchantWang){
						window.toast("请输入消商家旺旺号","txt");
						return
					}
				};
				
				if(!(/^1[0123456789]\d{9}$/.test(this.info.merchantMobile))){
					window.toast("商家手机号有误","txt");
					return
				}
				
				if(this.shouHouFlag=="1"){
					if(!(/^[1-9]\d*(,\d{3})*(\.\d{2})?$/).test(this.info.compensationPrice)){
						window.toast("补偿金输入有误","txt");
						return
					}
				}
				
				if(this.info.caseDetails){
					if(this.info.caseDetails.length>100){
						window.toast("实际情况描述不得超过500字符","txt");
						return
					}
				}
				
				if(!this.addBody.feedback_images.length){
					window.toast("请上传图片","txt");
					return
				}
				
				var obj={
					server_uuid:this.serverUuid,   		 //服务id
					server_type : this.serverType,  		 //服务类型(1,2)
					after_sale_type : this.shouHouFlag+1==0?"":this.shouHouFlag+1,    //售后类型 (1.2,3,4)
					question_url: this.info.linkUrl,  //链接
					consumer_name:this.info.consumerName,
					consumer_wangwang:this.info.consumerWang,
					consumer_mobile:this.info.consumerMobile,
					merchant_wangwang:this.info.merchantWang,
					merchant_mobile:this.info.merchantMobile,
					compensation_price:this.info.compensationPrice,		//补偿金额
					other_sale_massage: this.info.otherMassage,       //其他情况
					order_images:this.addBody.feedback_images,
					order_details:this.info.caseDetails,            //订单实际情况
					order_details_tag:this.situlation             //订单大概情况
				}

				if(this.isAdmin && this.isAdmin=="admin"){//管理员线下下单，用户填写的数据直接前端存储带过去
					obj.server_info ={};
					obj.server_info.server_icon =    this.serverIcon;
					obj.server_info.server_name =    this.serverName;
					obj.server_info.server_price =   this.serverPrice;
					
					obj.server_message = this.message;       //服务案例描述
					obj.after_sale_name	= this.afterSale    //售后名称
					sessionStorage.setItem("params",JSON.stringify(obj))
                    sessionStorage.setItem("newOrder","newOrder");
					this.$router.push({path:"./confirmorder-admin",query: {isAdmin:this.isAdmin}})
				}else{
					this.placeOrder(obj)
				}
            },
			
			// 服务下单
			async placeOrder(obj){
				const { data, status } = await placeOrder(obj);
				if (status !== 200) return 
				this.$router.push({path:"./confirmorder-admin",query: {order_uuid:data.order_uuid}});
                sessionStorage.setItem("placeOrderId",data.order_uuid);           //缓存下单服务下单生成的订单号，用户信息回填
			},
			
			// 弹框
			showPicker(type) {
				let columnArray;
				this.clickType = type;
				if(type==1){//	项目类型
					columnArray =this.serverList;
				}else if(type==2){//大致情况
					columnArray =this.column2;
				}
				
				this.picker = this.$createPicker({
					data: [columnArray],
					onSelect: this.selectHandle,
					onCancel: this.cancelHandle
				})

				this.picker.show()
			},
			
			// 选择项目
			selectHandle(selectedVal, selectedIndex, selectedText) {
				if(this.clickType==1){//	项目类型
					this.serverName = selectedText[0];
					this.serverPrice = this.serverList[selectedIndex[0]].server_price;
					this.serverType = this.serverList[selectedIndex[0]].type;
					this.serverIcon = this.serverList[selectedIndex[0]].server_icon;
					this.serverUuid = this.serverList[selectedIndex[0]].uuid;       //服务id
					this.caseImg = this.serverList[selectedIndex[0]].case_img;
					this.message = this.serverList[selectedIndex[0]].message;     //案例描述
					
					this.imgList = this.caseImg;
					if(this.imgList && this.imgList.length){
						this.imgList.forEach((idx,key)=>{
							if(idx.indexOf("https") == -1){
								this.imgList[key] = this.imgUrl + this.imgList[key]
							}
						})
					}
				}else if(this.clickType==2){//大致情况
					this.situlation = selectedText[0];
				}
			},
			
			//选择售后类型弹框
			selectService(e){
				this.isShowModal =true;
				e.preventDefault();
				document.body.style.overflow = "hidden"
			},
			
			//选择售后类型
			selectAfter(item,index){
				this.shouHouFlag = index;
				this.afterSale = item;
			},
			
			//确定售后类型
			submitAfter(){
				this.isShowModal =false;
				document.body.style.overflow = "auto"
			},
			
			// 关闭弹框
			onCloseModalClick(){
				this.shouHouFlag = -1      //用户关闭弹框，那么售后服务清空，只有点确定才算选择
				this.isShowModal =false;
				this.afterSale = "";
				this.isShowTips = false
				document.body.style.overflow = "auto";
			},
			
			lookExample(){
				// this.$refs.example.click();
				if(this.imgList && this.imgList.length){
					this.imgList.forEach((item,index)=>{
						this.handleImgsClick(this.imgList,index)
					})
				}
			},
			
			// 查看实例图片
			handleImgsClick(item,index) {
				if(item && item.length){
					this.initialIndex = index
					const params = {
						$props: {
						  imgs: item,
						  initialIndex: 'initialIndex', // 响应式数据的key名
						  loop: false
						},
						$events: {
							change: (i) => {
							// 必须更新 initialIndex
								this.initialIndex = i
							}
						}
					}
				  this.$createImagePreview({ ...params }).show()
				}
			}
		},
		
		components: {
			CommonModal,
		    CommonHeader,
		    submitPay,
			imageUpload
		}
    }
</script>

<style>
	.cube-picker-confirm {font-size: 15px;font-family: PingFangSC-Regular;font-weight: 400;color: rgba(65,132,244,1);}
	.cube-picker-cancel{font-size: 15px;font-family: PingFangSC-Regular;font-weight: 400;color:rgba(153,153,153,1)}
	.service-all .img-list .dankal-image-upload p{margin-right: 14px;margin-left: 0;}
	.service-all .img-list .dankal-image-upload p:nth-child(3n){margin-right: 0;}
	.service-all .img-list .dankal-image-upload .add-box{padding-left: 0;}
</style>

<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	::-webkit-input-placeholder { color:#999999;}
	::-moz-placeholder {color:#909;}
	::-moz-placeholder {color:#909;}
	::-ms-input-placeholder {color:#909;}
    section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5}
    .service-all{padding-bottom:72px;}
	.service-pro{display: -webkit-box;display: -ms-flexbox;display: flex;align-items: center;padding: 0 16px;background: #fff}
	.m-d{padding-bottom: 14px;border-bottom: 0.026667rem solid #EEEEEE;}
    .service-l{padding-top: 14px;padding-bottom: 9px;color: rgba(51,51,51,1);font-size: 17px}
    .service-title{.f-s(14);.p-t(10);.p-b(10);.p-l(16);color:rgba(153,153,153,1);}
	.tips{width:16px;height:16px}
    .service-content{position: relative;.h(52);.p-l(16);.p-r(16);.l-h(52);display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;border-bottom: 1px solid #EEEEEE;align-items: center;background: #fff}
	.server-icon{.w(19.5);.h(20);.m-r(5.5)}
    .service-left{color:rgba(51,51,51,1);text-align: justify;display: inline-block;vertical-align: top;.f-s(17)}
    .service-price{font-size:16px;color:rgba(51,51,51,1);text-align: right;-webkit-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}
    .service-right{.f-s(16);border: 0;display: inline-block;vertical-align: top;color:rgba(153,153,153,1);text-align: right;-webkit-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}
    .right-arrow-wrap{-webkit-box-flex: 1;-webkit-flex: 1;-ms-flex: 1;flex: 1;}
	.arrow{margin-top: 20px}
	.service-case{display: block;height:52px;line-height:52px;padding-right: 18px;float: right;font-size:16px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(51,51,51,1);font-style: normal;background: url(../../assets/images/home/ic_home_enter.png) right 50% no-repeat;background-size: 9px;}
    .right-arrow{display: block;.w(9);.h(15);float: right;background: url(../../assets/images/home/ic_home_enter.png) right 50% no-repeat;background-size: contain;overflow: hidden;}
    .goods-link{padding-left: 0.42666667rem;padding-right: 0.42666667rem;font-size: 0rem;line-height: 1.38666667rem;background: #fff}
    .goods-left{display: block}
	.area-pt{padding-top: 0.42666667rem;}
	.link-detail{width: 100%;height:95px;border: none;outline: none;line-height:19px;font-size:16px;;color:rgba(51,51,51,1);resize: none}
	.service-pay{font-size:16px;color: #333333}
	.img-upload{font-size:17px;color:rgba(51,51,51,1);}
	.img-expmle{font-size:14px;color:rgba(255,134,48,1);}
	.img-text{font-size:12px;color:rgba(153,153,153,1);padding-left: 16px;padding-bottom:16px;background: #fff}
    .img-list{padding: 0 16px;display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;justify-content: space-between;background: #fff}
    .img-list div{margin-bottom: 16px}
    .img-arr{width: 97px;height: 95px}
    .no-border{border: none}
    .have-border{border-bottom: 1px solid #EEEEEE;}
    .upload-img{width: 95px;height: 95px;background: url(../../assets/images/home/ic_home_add.png) center center no-repeat;background-size: cover;}
	.change-style{font-size: 15px;font-family: PingFangSC-Regular;font-weight: 400;}
	.upload_img{display: none}
	/* 弹框 */
	.modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
	.list-wrap{padding: 18px 21px 25px 21px;}
	.list-wrap li{margin-bottom: 10px}
	.select-mark{display: inline-block;width:18px;height:18px;margin-right: 7px;vertical-align: top;margin-top: 4px;box-sizing: content-box}
	.done{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.modal-text{display: inline-block;width: 243px;font-size:15px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);vertical-align: top;}
	.modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}
	.tips-all{width: 8.533333rem;background: #fff;margin: 0 auto;font-size: 18px; padding: 40px 20px 20px 20px;}

</style>

